import getKeysFromPreviousQueries from '@/lib/reactQueryHelpers/getKeysFromPreviousQueries';
import { useKeys } from '@refinedev/core';
import { QueryClient, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

interface ListFilters {
  filters: any;
}
interface UpdateQueryDataProps {
  resource: string;
  key?: string[];
  action?: 'list' | 'detail' | 'many' | 'one' | 'infinite';
  id?: string | number;
  path?: string | number[];
  listFilters?: ListFilters;
  object?: any;
  callbackFn?: ({
    queryKeys,
    data,
    queryClient,
  }: {
    queryKeys: any;
    data: any;
    queryClient: QueryClient;
  }) => any;
}

export const useCustomCacheUpdate = ({
  resource,
  key,
  id,
  path,
  action,
  object,
  callbackFn,
  dataProviderName = 'default',
}: {
  resource?: string;
  key?: string[];
  action?: string;
  id?: string | number;
  path?: string | number[];
  object?: any;
  callbackFn?: ({
    queryKeys,
    data,
    queryClient,
  }: {
    queryKeys: any;
    data: any;
    queryClient: QueryClient;
  }) => any;
  dataProviderName?: string;
}) => {
  const queryClient = useQueryClient();
  const { keys } = useKeys();
  // const { resources, select } = useResource();
  // const { identifier } = select(resource);

  const updateQueryCacheData = useCallback(
    (items: UpdateQueryDataProps[], data: any, opts: any = {}) => {
      items.forEach((item: UpdateQueryDataProps) => {
        const { resource, key, id, path, action, listFilters, object, callbackFn } = item;
        let queryKeys = null;
        let finalQueryKeys = null;
        const resourceKeys = keys().data(dataProviderName).resource(resource);
        if (action === 'list' || action === 'infinite') {
          const tempKey = resourceKeys.action(action).get(false);
          console.log('useCustomForm useCustomCacheUpdate tempKey', tempKey, action);

          if (listFilters) {
            queryKeys = [...tempKey, listFilters];
          } else {
            queryKeys = [...tempKey];
          }
          console.log('useCustomForm useCustomCacheUpdate queryKeys', queryKeys);
          // if(!opts.context){

          // } else {

          // }
          const previousData = queryClient.getQueriesData({ queryKey: tempKey });
          console.log('useCustomForm useCustomCacheUpdate previousData', previousData);
          console.log('useCustomForm useCustomCacheUpdate context', opts?.context);
          finalQueryKeys = getKeysFromPreviousQueries(previousData, queryKeys);
          console.log('useCustomForm finalQueryKeys', finalQueryKeys);
        } else if (action === 'detail' || action === 'one') {
          const tempKey = resourceKeys.action('one').id(id).get(false);
          console.log('useCustomForm useCustomCacheUpdate detail tempKey', tempKey, action);
          queryKeys = [...tempKey, `${id}`];
          console.log('useCustomForm useCustomCacheUpdate detail queryKeys 165', queryKeys);
          const previousData = queryClient.getQueriesData({ queryKey: tempKey, type: 'active' });
          finalQueryKeys = previousData.map(([cachedQueryKey, data]) => cachedQueryKey);
          // console.log('useCustomForm useCustomCacheUpdate detail previousData', previousData);
          // finalQueryKeys = getKeysFromPreviousQueries(previousData, queryKeys);
        }

        callbackFn && callbackFn({ queryKeys: finalQueryKeys, data, queryClient });
        // get previous queries

        // handle many later

        // console.log('useCustomForm tempKey', tempKey);
        // const tempData = queryClient.getQueriesData({ queryKey: tempKey, type: 'active' });
        // console.log('useCustomForm tempData', tempData);
      });
    },
    []
  );
  return { updateQueryCacheData };
};
